import module from 'module';

const templateUrl = require('./uid-ledger.template.html');
module.component('uidLedger', {
  templateUrl: templateUrl,
  bindings: {
    uidLedger: '<',
    showStatus: '<'
  },
  controller: function () {
  }
});